import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=12b46e23"
import script from "./notifications.js?vue&type=script&lang=js&external"
export * from "./notifications.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports